import React, { useState, useEffect, useRef } from 'react';
import { Grid } from '@mui/material';
import imageGIT from '@shared/assets/ImageSearchForm.jpg';
import imageMobile from '@shared/assets/mobileFlights.png';
import imageDesk from '@shared/assets/backgroundFlights.svg';

import RoundTripBase from './SearchTabs/RoundTrip';
import OneWayBase from './SearchTabs/OneWay';
import MultipleFlightsBase from './SearchTabs/MultipleFlights';
import { withForwardRef } from '@shared/helpers/withForwardRef';

import { FLIGHTS_SEARCH } from '@shared/helpers/routes';
import { useDispatch, useSelector } from 'react-redux';
import useWindowSize from '@shared/hooks/useWindowsSize';
import CurrencyOptions from './CurrencyOptions';
import useVersionControl from '@shared/hooks/useVersionControl';
import SearchPanel from '@shared/components/SearchPanel';
import FlightTypeSelector from './FlightTypeSelector';
import { useFlightSearchLogic } from './useFlightSearchLogic';

const RoundTrip = withForwardRef(RoundTripBase);
const OneWay = withForwardRef(OneWayBase);
const MultipleFlights = withForwardRef(MultipleFlightsBase);

const flightComponents = { RoundTrip, OneWay, MultipleFlights };

const FlightsSearchForm = ({
  setIsLoadingResults,
  setSearchResults,
  onRegisterSearchRef,
  isLoadingResults,
}) => {
  const dispatch = useDispatch();
  const { checkVersion } = useVersionControl(FLIGHTS_SEARCH);
  const screenSize = useWindowSize();

  const flightsSearch = useSelector(store => store.flightsSearch);
  const searchType = flightsSearch?.currentTripType;
  const infoFlightsSearch = flightsSearch[searchType];
  const { id } = useSelector(store => store.pageConfiguration);

  const [isInUSD, setIsInUSD] = useState(infoFlightsSearch?.is_in_usd ?? false);

  const bannerTdh = screenSize.width > 600 ? imageDesk : imageMobile;
  const image = id === 1 ? bannerTdh : imageGIT;

  const roundTripRef = useRef(null);
  const oneWayRef = useRef(null);
  const multiRef = useRef(null);

  const flightRefs = {
    RoundTrip: roundTripRef,
    OneWay: oneWayRef,
    MultipleFlights: multiRef,
  };

  useEffect(() => {
    setIsInUSD(infoFlightsSearch?.is_in_usd ?? false);
  }, [infoFlightsSearch?.is_in_usd]);

  const flightLogic = useFlightSearchLogic({
    setSearchResults,
    setIsLoadingResults,
    isInUSD,
    onRegisterSearchRef,
    ref: flightRefs[searchType],
    searchType,
    isLoadingResults,
  });

  const FlightComponent = flightComponents[searchType] || null;

  const commonProps = {
    setIsLoadingResults,
    setSearchResults,
    isInUSD,
    searchType,
    checkVersion,
    onRegisterSearchRef,
    isLoadingResults,
  };

  return (
    <SearchPanel
      title="Vuelos"
      image={image}
      gap="8px"
      header={
        <Grid container rowSpacing={{ xs: 1 }}>
          <Grid item xs={12} md={6} sx={{ order: { xs: 0, md: 1 } }}>
            <CurrencyOptions setIsInUSD={setIsInUSD} isInUSD={isInUSD} />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sx={{ order: { xs: 1, md: 0 }, alignSelf: 'flex-end' }}
          >
            <FlightTypeSelector
              {...{
                dispatch,
                searchType,
                searchPax: flightLogic.searchPax,
                flightClass: flightLogic.flightClass,
                airSectionRow: flightLogic.airSectionRow,
              }}
            />
          </Grid>
        </Grid>
      }
    >
      {FlightComponent && <FlightComponent {...commonProps} {...flightLogic} />}
    </SearchPanel>
  );
};

export default FlightsSearchForm;
